import { useQuery } from "@tanstack/react-query";
import { fetchContracts } from "@/api/contract/contract";
import { useAuth } from "@/providers/auth";

export const useContracts = ({
  queryFn,
  queryKey,
  fromContactId,
  ...rest
} = {}) => {
  const { cognitoId, userRole } = useAuth();

  return useQuery({
    queryKey: ["contracts", userRole, cognitoId],
    queryFn: async () => {
      return await fetchContracts({
        id: cognitoId,
        type: userRole,
      });
    },
    staleTime: 60 * 1000,
    ...rest,
  });
};
